// extracted by mini-css-extract-plugin
module.exports = {"container":"i_TB","image":"i_TC","address":"i_TD","label":"i_TE"};